"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LineWithOfferExpireDate;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../../../hooks/useTranslation"));
var _queryString = _interopRequireDefault(require("query-string"));
var _r10CommonComponents = require("r10-common-components");
var _reactRedux = require("react-redux");
var _selector = require("../../../selectors/selector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function LineWithOfferExpireDate(_ref) {
  var _useSelector;
  var endDateTime = _ref.endDateTime;
  var _queryString$parse = _queryString.default.parse(location.search),
    msisdn = _queryString$parse.msisdn;
  var dateFormat = (_useSelector = (0, _reactRedux.useSelector)(_selector.dateFormatSelector)) !== null && _useSelector !== void 0 ? _useSelector : 'DD/MM/YYYY';
  var t = (0, _useTranslation.default)();
  var _endDateTime$split = endDateTime.split('T'),
    _endDateTime$split2 = _slicedToArray(_endDateTime$split, 1),
    date = _endDateTime$split2[0];
  var breakPoint = (0, _r10SourceLibrary.useBreakpoints)();
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-details-line-with-expire-date"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: breakPoint.sm ? 3 : 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 2,
    justify: "center"
  }, t('upgrade_line'), " ", /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 3
  }, msisdn), /*#__PURE__*/_react.default.createElement("br", null), t('valid_until'), " ", /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 3
  }, _r10CommonComponents.utils.formatDate(date, dateFormat)))));
}
LineWithOfferExpireDate.propTypes = {
  endDateTime: _propTypes.default.string
};